<template>
    <div>
        <el-dialog title="测点信息" :visible.sync="dialogCheck.show" width="640px" center>
            <el-form ref="formEdit" :model="form" label-width="86px">

                <!-- 默认展示 -->
                <div class="form-inline">
                    <el-form-item label="监测项目" prop="object" class="form-group">
                        <el-input v-model="form.object" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="参数" prop="content" class="form-group">
                        <el-input v-model="form.content" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="测点编号" prop="measure_no" class="form-group">
                        <el-input v-model="form.measure_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="模块序列号" prop="measure_module" class="form-group">
                        <el-input v-model="form.measure_module" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="测点位置" prop="measure_address" class="form-group">
                        <el-input v-model="form.measure_address" disabled></el-input>
                    </el-form-item>
                     <el-form-item label="次数" prop="measureNumber" class="form-group">
                        <el-input v-model="form.measureNumber" disabled></el-input>
                    </el-form-item>
                </div>

                <!-- type值为1时展示 -->
                <div v-if="type == 1">
                    <div class="form-inline">
                        <el-form-item label="预警阀值" prop="earlyWarnValue" class="form-group">
                            <el-input v-model="form.earlyWarnValue" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值" prop="warnValue" class="form-group">
                            <el-input v-model="form.warnValue" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警率" prop="earlyWarnRate" class="form-group">
                            <el-input v-model="form.earlyWarnRate" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警率" prop="warnRate" class="form-group">
                            <el-input v-model="form.warnRate" disabled></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- type值为2时展示 -->
                <div id="type2" v-if="type == 2">
                    <div class="form-inline">
                        <el-form-item label="预警阀值" prop="earlyWarnValue" class="form-group">
                            <el-input v-model="form.earlyWarnValue" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值" prop="warnValue" class="form-group">
                            <el-input v-model="form.warnValue" disabled></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- type值为3时展示 -->
                <div id="type3" v-if="type == 3">
                   <div class="form-inline">
                        <el-form-item label="预警阀值1" prop="earlyWarnValue1" class="form-group">
                            <el-input v-model="form.earlyWarnValue1" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值1" prop="warnValue1" class="form-group">
                            <el-input v-model="form.warnValue1" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警阀值2" prop="earlyWarnValue2" class="form-group">
                            <el-input v-model="form.earlyWarnValue2" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值2" prop="warnValue2" class="form-group">
                            <el-input v-model="form.warnValue2" disabled></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- type值为4时展示 -->
                <div id="typethree" v-if="type == 4">
                    <div class="form-inline">
                        <el-form-item label="预警阀值1" prop="earlyWarnValue1" class="form-group">
                            <el-input v-model="form.earlyWarnValue1" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值1" prop="warnValue1" class="form-group">
                            <el-input v-model="form.warnValue1" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警阀值2" prop="earlyWarnValue2" class="form-group">
                            <el-input v-model="form.earlyWarnValue2" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警阀值2" prop="warnValue2" class="form-group">
                            <el-input v-model="form.warnValue2" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警率1" prop="earlyWarnRate1" class="form-group">
                            <el-input v-model="form.earlyWarnRate1" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警率1" prop="warnRate1" class="form-group">
                            <el-input v-model="form.warnRate1" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-inline">
                        <el-form-item label="预警率2" prop="earlyWarnRate2" class="form-group">
                            <el-input v-model="form.earlyWarnRate2" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报警率2" prop="warnRate2" class="form-group">
                            <el-input v-model="form.warnRate2" disabled></el-input>
                        </el-form-item>
                    </div>
                    <!-- <div class="form-inline" v-if="cedianNo == '0103' || '0106' ">
                        <el-form-item label="深度" prop="deepValue" class="form-group">
                            <el-input v-model="form.deepValue"></el-input>
                        </el-form-item>
                    </div>    -->
                </div>

                <!-- 默认展示 -->
                <div class="form-inline">
                    <el-form-item label="异常值" prop="measureOutliers" class="form-group">
                        <el-input v-model="form.measureOutliers" disabled></el-input>
                    </el-form-item>
                      <el-form-item label="常数值" prop="measureConstantValue" class="form-group">
                        <el-input v-model="form.measureConstantValue" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="测点别名" prop="alias" class="form-group">
                        <el-input v-model="form.alias" disabled></el-input>
                    </el-form-item>
                </div>

            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'measureInfo',
        /*prop类型*/
        props:{
          type:'',
          dialogCheck:Object,
          form:Object
        },
        data () {
            return {

            }
        },
        methods:{

        }
    }
</script>

<style>

  .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }

  .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }

    .el-form-item{
        margin-bottom: 8px;
    }

</style>

<style scoped>

    .form-group{
        display: inline-block
    }

</style>



// WEBPACK FOOTER //
// src/components/project/measure-info.vue